<template>
    <div class="dedicated-donation two grg10 gcg40 jstart">
        <div class="form-check two gcg10" v-for="radio in radioOptions">
            <input
                    class="form-check-input"
                    type="radio"
                    :name="name"
                    :id="radio.id"
                    :value="radio.value"
                    :checked="radio.checked"
                    @change="$emit('input', $event.target.value)" />
            <label class="form-check-label" :for="radio.id">
                {{ radio.label }}
            </label>
        </div>
    </div>
</template>

<script>
    export default {
        name: "RadioComponent",
        props: {
            radioOptions: Array,
            className: '',
            required: false,
            validate: true,
            name: ''
        },
        mounted() {
            for (let radio of this.radioOptions)
                if (radio.checked) {
                    this.$emit('input', radio.value);
                }
        }
    }
</script>

<style scoped>

</style>
